import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * "שיעורים פופולריים השבוע" — top-5 ranked list by clip-view count over
 * the past 7 days. Thumbnails omitted for now; rank badge + title +
 * view count only.
 */
import React from 'react';
import { Empty, Typography } from 'antd';
import { CardShell } from './CardShell';
import { PALETTE } from './helpers';
const { Text } = Typography;
export function TopLessonsCard({ data, loading, error, onReload }) {
    const lessons = data?.lessons ?? [];
    return (_jsx(CardShell, { title: "\u05E9\u05D9\u05E2\u05D5\u05E8\u05D9\u05DD \u05E4\u05D5\u05E4\u05D5\u05DC\u05E8\u05D9\u05D9\u05DD \u05D4\u05E9\u05D1\u05D5\u05E2", loading: loading && lessons.length === 0, error: error, onReload: onReload, skeletonRows: 5, bodyStyle: { padding: 0 }, children: lessons.length === 0 ? (_jsx("div", { style: { padding: 16 }, children: _jsx(Empty, { description: "\u05D0\u05D9\u05DF \u05E6\u05E4\u05D9\u05D5\u05EA \u05D1\u05E9\u05D1\u05D5\u05E2 \u05D4\u05D0\u05D7\u05E8\u05D5\u05DF", image: Empty.PRESENTED_IMAGE_SIMPLE }) })) : (_jsx("ol", { style: { listStyle: 'none', margin: 0, padding: 0 }, children: lessons.map((l, idx) => (_jsxs("li", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '12px 16px',
                    borderTop: idx === 0 ? 'none' : `1px solid ${PALETTE.gridLine}`,
                }, children: [_jsx("span", { style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 32,
                            height: 32,
                            borderRadius: 10,
                            background: idx === 0 ? PALETTE.lavAlt : '#F3EEF9',
                            color: PALETTE.purpleDeep,
                            fontWeight: 700,
                            flex: '0 0 auto',
                        }, children: idx + 1 }), _jsx(Text, { style: { flex: 1, color: PALETTE.ink, fontWeight: 500 }, ellipsis: true, children: l.title }), _jsxs(Text, { style: { color: PALETTE.inkMuted, fontSize: 13 }, children: [l.views.toLocaleString('he-IL'), " \u05E6\u05E4\u05D9\u05D5\u05EA"] })] }, l.lesson_id))) })) }));
}
